import React from 'react';
import VideoItem from '../../shared/components/VideoItem';
import { StyleSheet, css } from 'aphrodite/no-important';
import {constants} from '../constants';

const cssMediaItemSettings = {
	desktop: { item: { width: '360px' }},
	laptop: { item: { width: '300px' }},
	tablet: { item: { width: '223px' }},
	mobile: {
		item: { width: '46%' },
		firstItem: {
			width: '100%'
		},
		firstItemMeta: {
			marginLeft: '10px',
			marginRight: '10px'
		}
	}
};

class ThreeItems extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const posts = this.props.posts.slice(0, 3);
		let idx = 0;
		let outerIndex = 0;
		let utmObj = this.props.utmObj || {};
		let isShow = this.props.show ? this.props.show : false;
		let key = 1;

		return (
			<div className={css(this.props.containerStyle)}>
				{posts.map(p => (<VideoItem post={p} key={key++} isShow={ isShow } mediaSettings={cssMediaItemSettings} outerIndex={outerIndex++} innerIndex={idx++} utmObj={utmObj} classPostfix={constants.VC_CLASS_POSTFIX} />))}
			</div>
		);
	}
}

export default ThreeItems;



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/components/ThreeItems.js